import React from "react";
import { MaskReveal, Reveal } from "@/components/motion/Reveal";

const COLUMNS = [
  {
    label: "Venues",
    items: [
      { name: "Lío", place: "Ibiza" },
      { name: "Escape", place: "Amsterdam" },
      { name: "Gibson", place: "Frankfurt" },
    ],
  },
  {
    label: "Festivals",
    items: [
      { name: "Paradiso", place: "Netherlands" },
      { name: "Paaspop", place: "Netherlands" },
      { name: "Solar", place: "Netherlands" },
    ],
  },
  {
    label: "Brands",
    items: [
      { name: "Porsche", place: "Activation" },
      { name: "Mercedes-Benz", place: "Launch" },
      { name: "KLM", place: "Campaign" },
    ],
  },
];

const Ledger = ({ label, items, colIndex }) => (
  <div className="relative">
    <div className="flex items-center gap-3 pb-5 mb-2 border-b border-white/15">
      <span className="text-[11px] uppercase tracking-[0.35em] text-gold">{label}</span>
      <span className="text-[11px] text-white/30 tabular-nums">0{items.length}</span>
    </div>
    <ul>
      {items.map((it, i) => (
        <Reveal key={it.name} delay={colIndex * 0.05 + i * 0.06}>
          <li
            data-testid={`credential-${it.name.toLowerCase().replace(/[^a-z]/g, "")}`}
            className="group relative flex items-baseline justify-between gap-4 py-5 border-b border-white/[0.06] cursor-default"
          >
            {/* growing magenta rule */}
            <span className="absolute left-0 -bottom-px h-px w-0 bg-magenta transition-all duration-500 group-hover:w-full" />
            <div className="flex items-center gap-4 min-w-0">
              <span className="font-body text-xs text-white/25 tabular-nums pt-1 transition-colors duration-300 group-hover:text-magenta">
                {String(i + 1).padStart(2, "0")}
              </span>
              {it.logo ? (
                <img
                  src={it.logo}
                  alt={it.name}
                  className="h-8 sm:h-9 w-auto max-w-[190px] object-contain object-left opacity-70 transition-opacity duration-300 group-hover:opacity-100"
                />
              ) : (
                <span className="font-display text-4xl sm:text-5xl tracking-[0.06em] text-white/90 transition-all duration-300 group-hover:text-white group-hover:translate-x-1 truncate">
                  {it.name}
                </span>
              )}
            </div>
            <span className="shrink-0 text-[10px] uppercase tracking-[0.25em] text-white/35 transition-colors duration-300 group-hover:text-gold">
              {it.place}
            </span>
          </li>
        </Reveal>
      ))}
    </ul>
  </div>
);

export const Highlights = () => {
  return (
    <section id="highlights" className="relative py-28 lg:py-36 overflow-hidden border-y border-white/5">
      <div className="px-6 lg:px-16 max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16 lg:mb-24">
          <div className="lg:col-span-7">
            <Reveal><span className="text-xs uppercase tracking-[0.4em] text-gold">On The Bill</span></Reveal>
            <h2 className="mt-4 font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.82] tracking-wide text-white">
              <MaskReveal>WHERE SHE'S</MaskReveal>
              <MaskReveal delay={0.1}>PLAYED <span className="text-magenta">&</span> WHO</MaskReveal>
              <MaskReveal delay={0.18}>SHE'S PLAYED <span className="text-stroke">FOR</span></MaskReveal>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <Reveal delay={0.2}>
              <p className="max-w-sm text-white/55 leading-relaxed">
                A track record built across Europe's most demanding rooms — from Ibiza's tastemaker terraces to festival mainstages and the world's most exacting luxury brands.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Ledger */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14 lg:gap-20">
          {COLUMNS.map((c, i) => (
            <Ledger key={c.label} {...c} colIndex={i} />
          ))}
        </div>
      </div>

      <div className="pointer-events-none absolute -bottom-32 right-1/4 h-[360px] w-[360px] rounded-full bg-violet/15 blur-[140px]" />
    </section>
  );
};
